import React from 'react';
import { Paginator } from "primereact/paginator";

export const PaginatorContainer = (props) => {

    const { children, className, style, defaultRows } = props;
    const rowsPerPage = [5, 8, 10, 20, 30, 50];
    const [first, setFirst] = React.useState(0);
    const [rows, setRows] = React.useState(defaultRows || 20);

    const onPageChanges = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    }

    return (
        <>
            <div className={className} style={style}>
                {children.slice(first, first + rows)}
            </div>
            <Paginator first={first}
                rows={rows}
                totalRecords={children.length}
                rowsPerPageOptions={rowsPerPage}
                onPageChange={onPageChanges}></Paginator>
            <small style={{ position: 'relative', top: '-35px', left: "28%" }}>{`${children.slice(first, first + rows).length} from ${children.length}`}</small>
        </>
    );
}